import { useEffect } from 'react';
import notificationSound from '@assets/sounds/notification.wav';

/**
 * A short sound each time the working site's list gains something — a
 * conversation not listed before, or one with more unread. `arrivals` is
 * the bell's arrival count (`useArrivals`): it moves once per arrival, and
 * not on load or on a site switch.
 *
 * A browser plays sound only once the person has interacted with the page;
 * before that the play is refused, and the refusal is dropped — a sound is
 * not worth queuing. The file is two sine tones, E5 then A5, rendered once.
 */
export function useArrivalSound(arrivals: number): void {
  useEffect(() => {
    if (arrivals === 0) return;
    void new Audio(notificationSound).play().catch(() => {});
  }, [arrivals]);
}
